import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const StorePage = () => {
  const [isRedirecting, setIsRedirecting] = useState(true);
  const shopUrl = "https://opossol-shop.fourthwall.com";

  useEffect(() => {
    // Set a timeout to give users a moment to see the message
    const redirectTimer = setTimeout(() => {
      try {
        window.location.href = shopUrl;
      } catch (error) {
        setIsRedirecting(false);
        console.error("Redirect failed:", error);
      }
    }, 3000);

    return () => clearTimeout(redirectTimer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mystical-card">
            <h1 className="mystical-title text-black mb-8">
              Mystveil Merchandise Shop
            </h1>
            
            <div className="mystical-card bg-white bg-opacity-95 mb-8">
              <div className="h-px bg-gradient-to-r from-transparent via-purple-500 to-transparent max-w-md mx-auto animate-pulse mb-6"></div>
              <p className="mystical-text text-black text-lg mb-6">
                Redirecting you to our official merchandise store...
              </p>
              
              <div className="flex justify-center mb-6">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/" className="mystical-button">
                Return Home
              </Link>
              <Link to="/guide" className="mystical-button">
                View Guides
              </Link>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default StorePage;